import { FC } from 'react';
import { OrderCardInListing } from '../../views/orders/Components';
import { IDataShopping } from '../../types/orders';
import './SecondShoppingList.scss';

interface ISecondShoppingList {
  listingData?: IDataShopping;
  refreshData: () => void;
}

const SecondShoppingList: FC<ISecondShoppingList> = ({ listingData, refreshData }: ISecondShoppingList) => {
  return (
    <div id="secondShoppingList">
      <div className="noDateColumn">
        {listingData?.unDate?.items &&
          listingData?.unDate?.items.length > 0 &&
          listingData?.unDate?.items.map((item, index) => {
            return (
              <div className="centerCard" key={`card-item-${item.orderId}-${index}`}>
                <OrderCardInListing data={item} refreshData={refreshData} lockInternal specialCards />
              </div>
            );
          })}
      </div>
      <div className="dateColumn">
        {listingData?.withDate?.items &&
          listingData?.withDate?.items.length > 0 &&
          listingData?.withDate?.items.map((item, index) => {
            return (
              <div className="centerCard" key={`card-item-${item.orderId}-${index}`}>
                <OrderCardInListing data={item} refreshData={refreshData} lockInternal specialCards />
              </div>
            );
          })}
      </div>
      <div className="lateColumn">
        {listingData?.lateDate?.items &&
          listingData?.lateDate?.items.length > 0 &&
          listingData?.lateDate?.items.map((item, index) => {
            return (
              <div className="centerCard" key={`card-item-${item.orderId}-${index}`}>
                <OrderCardInListing data={item} refreshData={refreshData} lockInternal redHeader specialCards />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default SecondShoppingList;
